import { RedemptionResult } from '@api/redemption';
import { User } from 'firebase/auth';
import { Check } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { AccountDetails } from '../components/AccountDetails';
import { AppStoreButtons } from '../components/AppStoreButtons';
import { RedemptionLayout } from '../components/RedemptionLayout';

export const SuccessPage = ({
  user,
  status,
}: {
  user: User;
  status: RedemptionResult['status'];
}) => {
  const { t } = useTranslation();
  const alreadyRedeemed = status === 'already_redeemed';

  return (
    <RedemptionLayout step={2}>
      <div className="redemption-result">
        <div className="redemption-status-icon success">
          <Check size={32} aria-hidden="true" />
        </div>
        <h1>{t(alreadyRedeemed ? 'success_page.already_redeemed_title' : 'success_page.title')}</h1>
        <p className="redemption-body">
          {t(alreadyRedeemed ? 'success_page.already_redeemed' : 'success_page.subtitle')}
        </p>
        <AccountDetails user={user} />
        <p className="redemption-body">{t('success_page.login_instruction')}</p>
        <div className="redemption-download">
          <h2>{t('success_page.download_title')}</h2>
          <p>{t('success_page.download_prompt')}</p>
          <AppStoreButtons />
        </div>
        <p className="redemption-note">{t('success_page.existing_app')}</p>
        {alreadyRedeemed && (
          <div className="redemption-auth-switch">
            <p>{t('success_page.support_help')}</p>
            <a className="redemption-text-link" href="mailto:support@remente.com">
              {t('error_page.contact_support')}
            </a>
          </div>
        )}
      </div>
    </RedemptionLayout>
  );
};
